module.exports = __webpack_public_path__ + "img/Elizabeth.7f322501.jpg";